//helper function that picks size number of block identifiers out of blocks
function sampleBlocks(blocks, size){
    blocksCount = blocks.length;
    pickedBlocks = [];
    availableBlocks = blocks.slice();
    for(var i = 0; i < size; i++){
        const pickedIndex = window.getRandomInteger(0, blocksCount - 1);
        pickedBlocks.push(availableBlocks[pickedIndex]);
        availableBlocks.splice(pickedIndex, 1);
        blocksCount--;
    }

    return pickedBlocks;
}

//randomly pick blocks from the trial order and shuffle the position of picked blocks
//rule is an object with two attributes:
//blocks which is an array containing all the blocks identifiers(e.g. [1,2,3]) in the trial order
//size which is how many blocks are to be picked out of the rule.blocks attribute
function randomBlockPick(rule){
    var newOrder = [];
    const sampledBlocks = sampleBlocks(rule.blocks, rule.size);
    var blockLocation = {};

    var trials = window.trialList;

    //get locations of blocks
    for(var i = 0; i < trials.length; i++){
        const currentTrialBlock = columnForTrial('block', trials[i]);
        if(blockLocation[currentTrialBlock] !== undefined){
            blockLocation[currentTrialBlock].end = i;
        }
        else if(sampledBlocks.indexOf(currentTrialBlock) >= 0){
            blockLocation[currentTrialBlock] = {
                start: i,
                end: i
            };
        }
        // if(rule.blocks.indexOf(currentTrialBlock) < 0){
        //     newOrder.push(trials[i]);
        // }
    }

    var blockIndex = 0;

    //shuffle block trials
    for(var i = 0; i < trials.length; i++){
        const currentTrialBlock = columnForTrial('block', trials[i]);

        //push trials that are not part of a rule block to the new order
        if(rule.blocks.indexOf(currentTrialBlock) < 0){
            newOrder.push(trials[i]);
        }
        
        //found trial that is part of a rule block, 
        //start pushing all the trials of the block that's supposed to be shuffeled here
        //this also skips the trials of the blocks that were not picked
        else if(sampledBlocks.indexOf(currentTrialBlock) >= 0){
            //get block identifier of block that's going to be inserted
            const blockToBeInserted = sampledBlocks[blockIndex];
            for(var j = blockLocation[blockToBeInserted].start; j <= blockLocation[blockToBeInserted].end; j++){
                newOrder.push(trials[j]);
            }
            blockIndex++;
            //skip over the trials of the block that was here initially
            i+= (blockLocation[currentTrialBlock].end - blockLocation[currentTrialBlock].start);
        }
    }

    window.trialList = newOrder;
}

function pickBlocks(rule){
    var newOrder = [];
    const pickedBlocks = sampleBlocks(rule.blocks, rule.size);

    var trials = window.trialList;

    //eliminate blocks that weren't picked

    for(var i = 0; i < trials.length; i++) {
        const currentTrialBlock = columnForTrial('block', trials[i]);

        if(rule.blocks.indexOf(currentTrialBlock) < 0) {
            newOrder.push(trials[i]);
        }

        else if(pickedBlocks.indexOf(currentTrialBlock) >= 0){
            newOrder.push(trials[i]);
        }
    }
    window.trialList = newOrder;
}